/* 
        MX200 Sensor Controller 

        Supported sensors:
        Gas type and parameter Sensor MFG Gas Range species, PWM range, multiplier
        0 Luminox O2 25% 2, 25000, 10
        1 Luminox O2 50% 2, 50000, 10
        2 GSS CO2 1% 1, 10000, 1
        3 GSS CO2 5% 1, 5000, 10
        4 GSS CO2 20% 1, 20000, 10
        5 GSS CO2 65% 1, 65000, 10
        6 GSS CO2w 100% 1, 10000, 100
*/

/* 
  Hopefully fixed:

  Oct 13 19:26:02 raspberrypi fulljs[510]: system: Failed to update mx200co2: Error: ERROR_COMMAND_FAILED
  Oct 13 19:26:02 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
  Oct 13 19:26:03 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
  Oct 13 19:26:06 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
  Oct 13 19:26:09 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
  Oct 13 19:26:13 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
  Oct 13 19:26:16 raspberrypi fulljs[510]: system: Failed to update mx200co2: TypeError: This stream has already been locked for exclusive reading by another reader
*/


import {TextEncoder}	from "encoding";
import Bottleneck		from "bottleneck";
import sleep			from "sleep";
import Device from "../device.js";


const TIMEOUT = 500;

const ERROR_CODES = {
  1: "ERROR_UNRECOGNIZED_COMMAND",
  2: "ERROR_BAD_FORMAT",
  3: "ERROR_BAD_VALUE",
  4: "ERROR_BAD_DATE_STRING",
  5: "ERROR_RTC_WRITE",
  6: "ERROR_EEPROM_READ",
  7: "ERROR_BAD_PARAMETER",
  8: "ERROR_VALUE_ALREADY_SET",
  9: "ERROR_COMMAND_FAILED",
  10: "ERROR_NOT_IMPLEMENTED",
  11: "ERROR_NOT_CONFIGURED"
};


class Module extends Device {
  static constructor() {
    Module.MODE_COMMAND = 0;
    /* other modes are not implemented
    MX200.MODE_STREAMING = 1;
    MX200.MODE_POLLING = 2;
    */
  }
  constructor(serialPort) {    
    super(serialPort);
    
    this.id = "uninitialized";
    this.status = "uninitialized";    
    
    this.__serialPort = serialPort;

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });    

    /* publicate remote methods to clients */
    jfermi.RM_mx200co2_calibratezero = this.RM_mx200co2_calibratezero.bind(this);
    jfermi.RM_mx200co2_calibratespan = this.RM_mx200co2_calibratespan.bind(this);
  }
  async initialize() {
    try {            
      await this.__serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      
      this.status = "OK";

      //MX300 needs some warm-up time
      await sleep(2000);

      this.id = await this.getDeviceInformation();

      this.usbProductName = (await this.__serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.__serialPort.getInfo()).usbSerialNumber;   
      this.name = "mx200co2";
      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {                    
      this.value = await this.getFilteredGasConcentration();

      this.internalTemperature = await this.getInternalTemperature();
      this.internalBarometricPressure = await this.getInternalBarometricPressure();

      this.onBoardTemperature = await this.getOnBoardTemperature();
      this.onBoardBarometricPressure = await this.getOnBoardBarometricPressure();
      this.onBoardRelativeHumidity = await this.getOnBoardRelativeHumidity();
      this.status = "Ok";
    } catch(e) {
      this.value = "-";
      this.status = `Failed: ${e}`;
      throw e;      
    }      
  }
  async __flush() {
    var reader = this.__serialPort.readable.getReader();

    /* flush queue */
    try {      
      setTimeout(function() {
        reader.releaseLock();
      }, 10);      
      while (true) {        
        const chunk = await reader.read();     
        if (Module.logLevel>2) console.log(`flushing ${chunk.value.byteLength} bytes(s)`);
      }
    } catch(e) {
      if (!(e instanceof TypeError))
        throw e;
    }    
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {
    return await this.limiter.schedule(() => this.command_wrapped(command));
  }
  async command_wrapped(command) {
    await this.__flush();

    var reader;

    var promise = new Promise(async function(resolve, reject) {             
      const encoder = new TextEncoder();
      const writer = this.__serialPort.writable.getWriter();
      await writer.write(encoder.encode(`${command}\r\n`).buffer);
      writer.releaseLock();    
      reader = this.__serialPort.readable.getReader();

      var result = "";
            
      try {
        while (true) {
          const { value, done } = await reader.read();      
          result += String.fromCharCode.apply(null, new Uint8Array(value));      

          if (done) {
            // reader has been canceled.               
            reject( new Error("reader cancelled") );
            break;
          }        

          if (result.endsWith('\r\n')) {
            if (result.startsWith("E")) {
              result = result.replace("\r\n", "");
              result = result.replace(" ", "");
              result = result.replace("E", "");
              var error_code = parseInt(result);
              reject( new Error(ERROR_CODES[error_code]) );
              break;
            } else {
              result = result.replace("\r\n", "");
              result = result.replace(" ", "");
              result = result.replace(command, "");      
              resolve(result);
              break;
            }
          }
        } //while
        reader.releaseLock();  
      } catch(e) {
        if (e instanceof TypeError) {
          reject( new Error("timeout") );
        } else {  
          throw e;        
        }
      }
    }.bind(this));

    var promiseTimeout = new Promise(function(resolve, reject) {
      setTimeout(function() {        
        reader.releaseLock();        
        reject( new Error("timeout"));
      }, TIMEOUT);
    }.bind(this));

    return Promise.race([promise, promiseTimeout]);    

  }
  async getDeviceInformation() {
    return await this.command("Y");
  }
  async getSensorType() {
    return await this.command("G");
  }
  /* this command is not implemented
  async setCommunicationMode(mode) {
    await this.command(`K ${mode}`);
  }
  */
  async getFilteredGasConcentration() {
    var multiplier = await this.command(".");
    /* MX200 documentation: Note that 0 is used for a multiplier of 0.1 */
    if (multiplier==0) multiplier=0.1;
    var co2 = await this.command("Z");
    return multiplier * co2;
  }
  async getOnBoardRelativeHumidity() {
    var h = await this.command("H");
    return h/10;
  }
  /*  Get Temperature (O2 UV Flux sensor) */
  async getInternalTemperature() {
    var t = await this.command("T");
    t = t-1000;
    t = t/10;
    return t;
  }
  /* Get Temperature (On board RH & T sensor) */
  async getOnBoardTemperature() {
    var t = await this.command("t");
    t = t-1000;
    t = t/10;
    return t;
  }
  /*  Get internal baromteric pressure */
  async getInternalBarometricPressure() {
    var p = await this.command("b");
    p = parseInt(p);
    return p;
  }
  /* Get on-board Barometric Pressure (On board) */
  async getOnBoardBarometricPressure() {
    var p = await this.command("B");
    p = parseInt(p);
    return p;
  }
  /* 
         Basic Calibration
         Basic Calibration requires first that an accurate zero be set (typically with Nitrogen Gas at
         25C +- 1C) and then that a known gas concentration be provided (also at 25C +-1C) and
         allowed to completely stabilize.

         The zero-calibration point is set using the U command. The span reference point is set
         using the X command. When the X command is executed the microcontroller makes the
         necessary calculations and stores these in the parameter storage. 
  */
  async zeroCalibrateIn0ppm() {
    return await this.command("U");
  }
  async calibrateTo(ppm) {
    var multiplier = await this.command(".");
    /* MX200 documentation: Note that 0 is used for a multiplier of 0.1 */
    if (multiplier==0) multiplier=0.1;
    ppm /= multiplier;
    ppm = Math.round(ppm);
    return await this.command(`X ${ppm}`);
  }
  async RM_mx200co2_calibratezero(request) {
    try {
      var result = await this.zeroCalibrateIn0ppm();
      console.log(`${request.client.username}: O2 sensor zero point has been calibrated.`);
    } catch(e) {
      console.error(`${request.client.username}: O2 sensor calibration failed: ${e}`);
      throw Error(e);
    }
    return true;
  }
  async RM_mx200co2_calibratespan(request, ppm) {
    try {
      var result = await this.calibrateTo(ppm);
      console.log(`${request.client.username}: O2 sensor has been calibrated.`);
    } catch(e) {
      console.error(`${request.client.username}: O2 sensor calibration failed: ${e}`);
      throw Error(e);
    }
  }  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,
      value: this.value,
      internalTemperature: this.internalTemperature,
      internalBarometricPressure: this.internalBarometricPressure,
      onBoardTemperature: this.onBoardTemperature,
      onBoardBarometricPressure: this.onBoardBarometricPressure,
      onBoardRelativeHumidity: this.onBoardRelativeHumidity
    });
  }
}

Module.logLevel = 2;

Module.constructor();

export default Module;